import React, { useRef } from 'react';
import { motion, useMotionValue, useSpring, useTransform, useMotionTemplate } from 'framer-motion';

/* 3D tilt on hover with a moving light glare + spotlight. Falls back to a flat card on touch. */
export default function TiltCard({ children, className = '', max = 10, scale = 1.02, glare = true, style, ...rest }) {
  const ref = useRef(null);
  const px = useMotionValue(0.5);
  const py = useMotionValue(0.5);
  const sx = useSpring(px, { stiffness: 180, damping: 18 });
  const sy = useSpring(py, { stiffness: 180, damping: 18 });
  const rotateY = useTransform(sx, [0, 1], [-max, max]);
  const rotateX = useTransform(sy, [0, 1], [max, -max]);
  const gx = useTransform(sx, (v) => `${v * 100}%`);
  const gy = useTransform(sy, (v) => `${v * 100}%`);
  const glareBg = useMotionTemplate`radial-gradient(420px circle at ${gx} ${gy}, rgba(255,255,255,.35), transparent 45%)`;

  const onMove = (e) => {
    if (e.pointerType === 'touch') return;
    const r = ref.current.getBoundingClientRect();
    px.set((e.clientX - r.left) / r.width);
    py.set((e.clientY - r.top) / r.height);
  };
  const reset = () => { px.set(0.5); py.set(0.5); };

  return (
    <motion.div ref={ref} className={`tilt ${className}`} onPointerMove={onMove} onPointerLeave={reset}
      style={{ rotateX, rotateY, transformPerspective: 1000, transformStyle: 'preserve-3d', ...style }}
      whileHover={{ scale }} transition={{ type: 'spring', stiffness: 260, damping: 22 }} {...rest}>
      {children}
      {glare && <motion.span className="tilt-glare" style={{ background: glareBg }} aria-hidden="true" />}
    </motion.div>
  );
}
